module.exports = __webpack_public_path__ + "static/media/paper-check-2.03d69510.png";